<template>
	<div>
        <div class="dashboard-widget-tabs">
            <div class="dashboard-widget-tabs-content padding-m" style="margin: 0;border: 0;padding: 0;">
                <h2>
                    <i class="uil uil-comment-alt-lines"></i> اتاق‌های گفت‌وگو
                </h2>
                <div class="dashboard-widget-help">
                    <i class="uil uil-question-circle"></i>
                </div>
            </div>
        </div>
        <div :class="'row tgju-widgets-row profile-post-widgets '+ market_tab +''">
            <div class=" tgju-widgets-block col-12 col-md-6 col-xl-8">
                <div :class="'widget-select w-100w '+ discussion_active.text +''">
                    <v-select v-model="discussion_active" @input="componentKey += 1,setMarketTab(discussion_active.text)" :clearable="false" label="value" :options="discussions">
                        <i class="uil uil-list-ui-alt"></i>
                    </v-select>
                </div>
                <Post type="widget" auth="hide" username="everybody" sendbox="enabled" :subject="discussion_active.text" :title="discussion_active.value"  col="" :key="componentKey"></Post>
            </div>
            <div class=" tgju-widgets-block col-12 col-md-6 col-xl-4">
                <!-- <ProfileFriendItems :username="username()"></ProfileFriendItems> -->
                <div class="tgju-widget last-post light">
                    <div class="list-widget  list-row bold list-row-title border-0">
                        <div class="list-col l-title dot head-color no-border">
                        <span>اتاق‌های گفت‌وگو</span>
                        </div>
                        <div class="list-col l-item  head-color">
                        <i class="uil uil-comment-alt-lines"></i>
                        </div>
                    </div>
                    <div class="tgju-widget-content full-padding">

                        <div v-for="discussion in discussions" :key="discussion.text" :class="'discussion-row ' + discussion.text + (market_tab == discussion.text ? ' active' : '')"  @click.prevent="setMarketRow(discussion)">
                            <div class="discussion-icon"></div>
                            <h3>{{discussion.value}}</h3>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
    </div>
</template>

<script>
    // این ویو برای مازول اتاق‌های گفت‌وگو استفاده میشود
    // @ is an alias to /src
    import Post from '@/components/TgjuPosts/Post.vue'
	// import ProfileFriendItems from '@/componentsgit/ProfileFriendItems.vue'
	import vSelect from 'vue-select'
	Vue.component('v-select', vSelect);

    export default {
        name: 'Forums',
        data: function () {
            return {
                market_tab : 'tgju-discussion-18',
                componentKey: 0,                
                discussion_active: {text: 'tgju-discussion-18', value: 'بازار طلا'},
                discussions: [
                    {text: 'tgju-discussion-18', value: 'بازار طلا'}, 
                    {text: 'tgju-discussion-19', value: 'بازار سکه'},
                    {text: 'tgju-discussion-20', value: 'بازار ارز'},
                    {text: 'tgju-discussion-global-2', value: 'بازار ارزهای دیجیتال'},
                    {text: 'tgju-discussion-28', value: 'بازار بورس'},
                    {text: 'tgju-discussion-36', value: 'بازار های کالایی'},
                    {text: 'tgju-discussion-global-1', value: 'بازار های سهام'},
                    {text: 'tgju-discussion-37', value: 'بازار نفت و انرژی'},
                    {text: 'tgju-discussion-global-3', value: 'بازار مبادلات ارزی'},
                    {text: 'tgju-discussion-35', value: 'بازار فلزات'}
               ],
            }
        },
        components: {
            Post,
            // ProfileFriendItems,

        },
        methods: {
            // این متد برای هندل کردن اکشن تغییر دسته بندی نظرات استفاده میشود
            onChange(event) {
                this.discussion = event.target.value;
                this.componentKey += 1
            },
            // این متد نام کاربری را بر می گرداند
            username() {
				return this.$route.params.username ? this.$route.params.username : this.$store.state.user.username
			},
            // این متد برای تغییر و هایلایت کردند بازار انتخاب شده مورد استفاده قرار میگیرد
            setMarketTab(elm) {
               this.market_tab = elm;
            },
            // این متد جهت هندل کردن روی منوی های سمت چپ اتاق گفتگو
            // که باعث تغییر کانال نظرات میشود
            setMarketRow(elm) {
               this.market_tab = elm.text;
               this.discussion_active = elm;
            },
        }
    }
</script>